import Typography from '@mui/material/Typography';
import MuiListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StarIcon from '@mui/icons-material/Star';
import { GradientIcon } from 'src/components/gradients/GradientIcon';
import { useTheme } from '@mui/material/styles';
import { Link } from '../../../components/Link';
import { truncateIfTooLong } from 'src/util/truncate';
import { Member } from 'functions/src/types/firestore/Game/Tournament/Guestlist';
import { AvatarNext } from 'src/components/AvatarNext';
import { ParticipantAdminDetails } from './ParticipantAdminDetails';
import { useAuth } from 'src/contexts/AuthContext';
import { isAdmin } from 'functions/src/types/firestore/User/util';

export type ParticipantProps = {
  isSolo?: boolean;
  attributes?: string[];
} & Member;
export default function Participant({
  isSolo = false,
  ...rest
}: ParticipantProps) {
  const theme = useTheme();
  const { imgUrl, username, userId, checkedIn, status, ...memberAdminDetails } =
    rest;
  const { user } = useAuth();
  const isAuthenticated = isAdmin(user?.email);

  return (
    <MuiListItem
      sx={{
        borderBottom: `1px ${theme.palette.other.textSecondaryShades.opacity30} solid`,
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'background.elevation.2',
      }}
    >
      <Link
        href={`/profile/${userId}`}
        sx={{ textDecoration: 'inherit', color: 'inherit' }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pl: 12,
            '& :nth-of-type(n)': {
              mx: 1,
            },
          }}
        >
          <AvatarNext
            sx={{
              backgroundColor: '#242A62',
              color: '#242A62',
              width: '35px',
              height: '35px',
            }}
            alt="competitor image"
            src={imgUrl}
          />
          <Typography
            variant="subtitle2"
            sx={{ textTransform: 'uppercase', pl: 2 }}
            color={username ? 'text.primary' : 'text.secondary'}
          >
            {truncateIfTooLong(username, 25)}{' '}
            {isAuthenticated && (
              <ParticipantAdminDetails {...memberAdminDetails} />
            )}
          </Typography>
          {status === 'captain' && (
            <GradientIcon
              IconComponent={StarIcon}
              gradientColor="primary.horizontal"
              sx={{ p: 0.5 }}
            />
          )}
        </Box>
      </Link>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          {isSolo && 'Solo'}
          {status === 'captain' && 'Team Captain'}
        </Typography>
        {checkedIn && (
          <CheckCircleIcon
            sx={{
              p: 0.5,
              ml: 1,
              alignSelf: 'center',
              color: `${theme.palette.secondary.main}`,
            }}
          />
        )}
      </Box>
    </MuiListItem>
  );
}
